import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Dashboard|Ban Section|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateBanSection';
export type SPCandidateBanSectionLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelBanned`
	| `${LocNameStart}LabelBannedUntil`
	| `${LocNameStart}NotificationStatusUpdateSuccess`
	| `${LocNameStart}NotificationStatusUpdateFailure`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`;

export const spCandidateBanSectionLocs: LocDefs<SPCandidateBanSectionLocNames> = {
	SPCandidateBanSectionTitleSection: {
		defaultValue: 'Ban',
		description: 'Title for: Ban.',
		displayPath: `${pathStart}Ban`,
		displayType: 'Title',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Title.BanSection',
		...sharedProperties,
	},
	SPCandidateBanSectionLabelBanned: {
		defaultValue: 'Banned',
		description: 'Label for: Banned.',
		displayPath: `${pathStart}Banned`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Banned',
		...sharedProperties,
	},
	SPCandidateBanSectionLabelBannedUntil: {
		defaultValue: 'Banned Until',
		description: 'Label for: Banned Until.',
		displayPath: `${pathStart}Banned Until`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.BannedUntil',
		...sharedProperties,
	},
	SPCandidateBanSectionNotificationStatusUpdateSuccess: {
		defaultValue: 'Candidate status successfully updated',
		description: 'Notification for: Candidate status successfully updated.',
		displayPath: `${pathStart}Status Update Success`,
		displayType: 'Notification',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.NotificationMessage.UpdateSuccess',
		...sharedProperties,
	},
	SPCandidateBanSectionNotificationStatusUpdateFailure: {
		defaultValue: 'Something went wrong, please contact support',
		description: 'Notification for: Status update failed.',
		displayPath: `${pathStart}Status Update Failure`,
		displayType: 'Notification',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.NotificationMessage.UpdateFailure',
		...sharedProperties,
	},
	SPCandidateBanSectionButtonEdit: {
		defaultValue: 'Edit',
		description: 'Button for editing banned status',
		displayPath: `${pathStart}Edit Ban`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateBanSectionButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button to cancel editing banned status',
		displayPath: `${pathStart}Cancel Edit`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateBanSectionButtonUpdate: {
		defaultValue: 'Remove or Update Ban',
		description: 'Button to update banned status',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPCandidateBanSectionLocType = LocMap<SPCandidateBanSectionLocNames>;
